import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { actionAppToSmallScreen } from "./AppRedux";
import CssBaseline from "@mui/material/CssBaseline";
import Auth from "../Auth";
import Map from "../Map";
import AppBar from "../AppBar";
import AccordionContainer from "./AccordionContainer";
import Widgets from "./Widgets";
import Layer from "../Layer";
import { CustomLayerRestroom } from "../CustomLayer";
import Info from "../Info";
import SearchResult from "../Data";
import Print from "../Print";
import Draw from "../Draw";
import Legend from "../Legend";
import Search from "../Search";
import Zoom from "../Zoom";
import Rotate from "../Rotate";
import MapviewControl from "../MapviewControl";
import Photo from "../Photo";
import AlertManager from "../Alert";
import Scale from "../ScaleGrid";
import Spreadsheet, {
  Upload,
  DragAndDrop,
  SharedDatasetFileList,
} from "../Spreadsheet";
import ReactGA from "react-ga4";

const ACCORDIONS = {
  resultDataVisibile: <SearchResult key="data" />,
  infoVisible: <Info key="info" />,
  layersVisible: <Layer key="layer" />,
  customLayerRestroomVisible: <CustomLayerRestroom key="customlayerrestroom" />,
  printVisible: <Print key="print" />,
  drawVisible: <Draw key="draw" />,
  legendVisible: <Legend key="legend" />,
  spreadsheetVisible: <Spreadsheet key="spreadsheet" />,
};

export default function App() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const xsDown = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    dispatch(actionAppToSmallScreen(xsDown));
  }, [dispatch, xsDown]);

  useEffect(() => {
    const googleTag = import.meta.env.VITE_GA4_TAG;
    if (googleTag) {
      try {
        ReactGA.initialize(import.meta.env.VITE_GA4_TAG, {
          testMode: window.location.hostname === "localhost", // enable test mode for localhost to avoid sending data to GA4 during development
          gtagOptions: {
            send_page_view: false,
          },
        });
      } catch (e) {
        console.error(e);
      }
    }
  });

  const accordions = useSelector((state) => state.appReducer.accordions);
  const accordionElts = accordions.map((accordion) => ACCORDIONS[accordion]);

  return (
    <>
      <CssBaseline />
      <Auth />
      <AlertManager />
      <div>
        <DragAndDrop>
          <Map />
          <AppBar />
          <AccordionContainer>{accordionElts}</AccordionContainer>
          <Search />
          <Upload />
          <SharedDatasetFileList />
          <Widgets>
            <MapviewControl />
            <Rotate />
            <Zoom />
          </Widgets>
          <Photo />
          <Scale />
        </DragAndDrop>
      </div>
    </>
  );
}
